import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "card-back"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  style: {
    "color": "#1C1C1C",
    "line-height": "1.5rem"
  }
};
import { pageStyle } from "@/theme/sliderStyle";
export default {
  __name: 'HomePage',

  setup(__props) {
    // import { onMounted, onBeforeUnmount } from 'vue'
    // import { socket } from '@/manager/socket_manager'
    const version_update = require('../../../static/external_version_update_250925.json'); // onMounted(() => {
    //   socket.on('message', handleNotification)
    // })
    //
    // onBeforeUnmount(() => {
    //   socket.off('message', handleNotification)
    // })
    //
    // const handleNotification = (data) => {
    //   console.log('Received:', data)
    // }
    // const sendMessage = () => {
    //   socket.send({ type: 'chat', content: 'Hello Vue!' })
    // }


    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("text", _hoisted_2, [_cache[0] || (_cache[0] = _createTextVNode(" 当前资料片：", -1)), _createElementVNode("b", null, _toDisplayString(_unref(version_update).expansion_pack), 1)]), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _createElementVNode("text", null, "          " + _toDisplayString(_unref(version_update).desc), 1), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(version_update).content, (item, key, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("b", null, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.desc, (desc_item, desc_key, desc_index) => {
          return _openBlock(), _createElementBlock("div", {
            key: desc_index
          }, [_createTextVNode(_toDisplayString(desc_item) + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))]);
        }), 128)), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))]);
      }), 128))])])], 4);
    };
  }

};